// แทน react-toastify ด้วย sweetalert2 (มีในโปรเจกต์อยู่แล้ว) — ไม่ต้องติดตั้งแพ็กเกจเพิ่ม
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (el) => {
    el.addEventListener('mouseenter', Swal.stopTimer);
    el.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

const show = (icon) => (msg) => Toast.fire({ icon, title: String(msg ?? '') });

export const toast = {
  success: show('success'),
  error: show('error'),
  warning: show('warning'),
  warn: show('warning'),
  info: show('info'),
};

export function ToastContainer() { return null; }
export default toast;
